// extracted by mini-css-extract-plugin
export var border = "IntroCircleImageAndSearch-module--border--66a79";
export var bordersection = "IntroCircleImageAndSearch-module--bordersection--27825";
export var contentarea = "IntroCircleImageAndSearch-module--contentarea--82813";
export var first = "IntroCircleImageAndSearch-module--first--9525c";
export var imagewrapper = "IntroCircleImageAndSearch-module--imagewrapper--4cf35";
export var introcirclewithsearchcontainer = "IntroCircleImageAndSearch-module--introcirclewithsearchcontainer--40bdb";
export var maintenanceimage = "IntroCircleImageAndSearch-module--maintenanceimage--c13fb";
export var search = "IntroCircleImageAndSearch-module--search--5685f";
export var second = "IntroCircleImageAndSearch-module--second--75a35";
export var subtitle = "IntroCircleImageAndSearch-module--subtitle--151c5";
export var text = "IntroCircleImageAndSearch-module--text--92db7";
export var title = "IntroCircleImageAndSearch-module--title--8738d";
export var titlewrapper = "IntroCircleImageAndSearch-module--titlewrapper--820f7";